export default __webpack_public_path__ + "static/media/manual-sagawa.660bff42.png";